// Perx Overwatch permission catalog: client mirror of the backend mapping (Confluence page 4472242178,
// features/PLA-9674/roles/be-permissions.md). Keys are frozen on the wire; every key, the three
// actions included, is granted with `view`. Key order is display order. PLA-9674.

import _startCase from 'lodash/startCase';

export { childrenOf } from './customerIntelligence';

export const OW_ROOT = 'perx_overwatch';

export const OW_BUSINESS_OVERVIEW = `${OW_ROOT}.business_overview`;

export const OW_SYSTEM_SUPPORT = `${OW_ROOT}.system_and_support`;

export const OW_SCREENS = [OW_BUSINESS_OVERVIEW, OW_SYSTEM_SUPPORT];

export const OW_MENU_LABEL = 'Perx Overwatch';

// The action keys: each is drawn indented beneath its parent and never counted as a section.
export const OW_ORBIT = `${OW_ROOT}.use_perx_orbit_for_layer_6`;

export const OW_SCHEDULE_RENEWAL_REVIEW = `${OW_BUSINESS_OVERVIEW}.contract_summary_and_commercial_terms.schedule_renewal_review`;

export const OW_BOOK_A_DEMO = `${OW_BUSINESS_OVERVIEW}.explore_more_with_perx.book_a_demo`;

export const OW_ACTION_KEYS = [OW_ORBIT, OW_SCHEDULE_RENEWAL_REVIEW, OW_BOOK_A_DEMO];

export const actionKeyOf = (parent: string): string | undefined =>
  OW_ACTION_KEYS.find(key => key.slice(0, key.lastIndexOf('.')) === parent);

// `audit_log` is not in the backend mapping; it stays so the section shows if the catalog gains it.
export const OW_LABELS: Record<string, string> = {
  [OW_ROOT]: 'View Perx Overwatch',
  [`${OW_ROOT}.use_perx_orbit_for_layer_6`]: 'Use Perx Orbit for Layer 6',

  [OW_BUSINESS_OVERVIEW]: 'View Business Overview',
  [`${OW_BUSINESS_OVERVIEW}.campaign_performance`]: 'View Campaign Performance',
  [`${OW_BUSINESS_OVERVIEW}.engagement_summary`]: 'View Engagement Summary',
  [`${OW_BUSINESS_OVERVIEW}.campaign_attention`]: 'View Campaign Attention',
  [`${OW_BUSINESS_OVERVIEW}.execution_status`]: 'View Execution Status',
  [`${OW_BUSINESS_OVERVIEW}.performance_and_user_growth`]: 'View Performance & User Growth',
  [`${OW_BUSINESS_OVERVIEW}.detected_anomalies_and_required_actions`]:
    'View Detected Anomalies & Required Actions',
  [`${OW_BUSINESS_OVERVIEW}.operational_visibility`]: 'View Operational Visibility',
  [`${OW_BUSINESS_OVERVIEW}.executive_commercial_intelligence`]:
    'View Executive Commercial Intelligence',
  [`${OW_BUSINESS_OVERVIEW}.contract_summary_and_commercial_terms`]:
    'View Contract Summary & Commercial Terms',
  [`${OW_BUSINESS_OVERVIEW}.contract_summary_and_commercial_terms.schedule_renewal_review`]:
    'Schedule Renewal Review',
  [`${OW_BUSINESS_OVERVIEW}.your_perx_capabilities`]: 'View Your Perx Capabilities',
  [`${OW_BUSINESS_OVERVIEW}.explore_more_with_perx`]: 'View Explore More with Perx',
  [`${OW_BUSINESS_OVERVIEW}.explore_more_with_perx.book_a_demo`]: 'Book a Demo',
  [`${OW_BUSINESS_OVERVIEW}.whats_new_in_perx`]: 'View What’s New in Perx',
  [`${OW_BUSINESS_OVERVIEW}.weekly_updates`]: 'View Weekly Updates',

  [OW_SYSTEM_SUPPORT]: 'View System & Support',
  [`${OW_SYSTEM_SUPPORT}.system_health_overview`]: 'View System Health Overview',
  [`${OW_SYSTEM_SUPPORT}.sla_plan_details`]: 'View SLA Plan Details',
  [`${OW_SYSTEM_SUPPORT}.incident_and_maintenance_board`]: 'View Incident & Maintenance Board',
  [`${OW_SYSTEM_SUPPORT}.create_support_ticket`]: 'Create Support Ticket',
  [`${OW_SYSTEM_SUPPORT}.active_support_tickets`]: 'View Active Support Tickets',
  [`${OW_SYSTEM_SUPPORT}.enterprise_knowledge_base_and_playbooks`]:
    'View Enterprise Knowledge Base & Playbooks',
  [`${OW_SYSTEM_SUPPORT}.security_and_audit_compliance_documents`]:
    'View Security & Audit Compliance Documents',
  [`${OW_SYSTEM_SUPPORT}.approved_platform_technology_and_engine_versions`]:
    'View Approved Platform Technology & Engine Versions',
  [`${OW_SYSTEM_SUPPORT}.audit_log`]: 'View Audit & Activity Log'
};

export const OW_KEYS = Object.keys(OW_LABELS);

export const isOverwatchKey = (resourceName: string): boolean =>
  resourceName === OW_ROOT || resourceName.startsWith(`${OW_ROOT}.`);

export const labelOf = (resourceName: string): string =>
  OW_LABELS[resourceName] ?? _startCase(resourceName.split('.').pop() ?? resourceName);
